import { render, staticRenderFns } from "./dialogWechat.vue?vue&type=template&id=798e243a&"
import script from "./dialogWechat.vue?vue&type=script&lang=js&"
export * from "./dialogWechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports